
<template>
      <div></div>
    </template>

<script>
      export default {
      mounted() {

      var pkDiamCoB = this.$store.state.storeCoA.coA.diametre.pkDiametre
      var typeDiametreCoB = this.$store.state.storeCoA.coA.diametre.typeDiametre
        this.obj = {  
          'coB' : {
            'diametre' : {
              pkDiametre: pkDiamCoB,
              typeDiametre: typeDiametreCoB
        }
        }};
       
        this.$store.commit('SET_CHOICE_COB', this.obj )


  
        //Code ref structure
        /*
        this.objStructure = {  
          'cable' : {
            'structure' : {
              codeRefStructure: codeRefStructure,
        }
        }};

        this.$store.commit('SET_CHOICE_CABLE', this.objStructure )
*/
         },     
      }
      </script>